import { render, staticRenderFns } from "./kdxHintTooltip.g.vue?vue&type=template&id=986cae92&scoped=true"
import script from "./kdxHintTooltip.g.vue?vue&type=script&lang=js"
export * from "./kdxHintTooltip.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHintTooltip.g.vue?vue&type=style&index=0&id=986cae92&prod&scoped=true&lang=scss"
import style1 from "./kdxHintTooltip.g.vue?vue&type=style&index=1&id=986cae92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986cae92",
  null
  
)

export default component.exports